import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  inline?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  size = 'md',
  inline = false,
}) => {
  return (
    <div className={`loading-spinner-container ${inline ? 'loading-spinner-inline' : 'loading-spinner-block'} loading-spinner-${size}`} role="status" aria-live="polite">
      <span className="loading-spinner-icon" aria-hidden="true" />
      {message && <span className="loading-spinner-message">{message}</span>}
    </div>
  );
};

export default LoadingSpinner;
